import { client } from 'services/api-client';

const getUser = async ({ token }) => {
  const user = await client('users/me', { token });

  return user;
};

export { getUser };
